angular.module("dx.webapp.support", [
	"digiexam.services.faults",
	"dx.webapp.api",
	"dx.webapp.session",
	"dx.webapp.angular",

	"dx.ui.components.localize",
	"dx.ui.components.dialog",
]);
